import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetMailReports = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_mail}`,
    params: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargesReports = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_charges}`,
    params: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargesReportsCSV = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_charges}.csv`,
    params: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargesReportsCSVLvl3 = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_charges_lvl3}.csv`,
    params: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const EnableAllMonthsInChargesReport =  () => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.enable_all_month_in_charges_report}`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargeDetails = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_charges}/detail`,
    params: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargeDetailsCSV = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_charges}/detail.csv`,
    params: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargeReportLvl3 = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.reports_charges_lvl3,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetNetRevenue = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.reports_revenue,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetPhoneRevenue = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.reports_phone,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargebacksRefunds = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.reports_chargebacks_refunds
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetChargeReportLvl1 = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.reports_charges_lvl1,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetSalesReportStatus = (level) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_sales}/l${level}/check_running_status`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetSalesReport = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_sales}/l${data.level}`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateSalesReportItem = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.reports_sales}/l${data.level}/${data.id}`,
    data: {
      sales_report_item: {
        [data.name]: data.value
      }
    }
  }
  
  return axios(requestOptions)
    .then(res => res.data);
}

export const RunSalesReport = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.reports_sales}/l${data.level}/calculate`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetManualColumns = (level) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_sales}/l${level}/manual_columns`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddManualColumn = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.reports_sales}/l${data.level}/manual_columns`,
    data: {
      manual_column: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateManualColumn = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.reports_sales}/l${data.level}/manual_columns/${data.col_name}`,
    data: {
      manual_column: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteManualColumn = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.reports_sales}/l${data.level}/manual_columns/${data.col_name}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UploadSalesReport = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.reports_sales}/l${data.level}/import`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetManagers = (level) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_sales}/l${level}/account_managers`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomersReport = (params) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_customers}`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomersReportCSV = (params) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_customers_csv}`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetYearlyRevenueReport = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_yearly_revenue}/l${data.level}`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetOrgReport = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.reports_organizations}`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}